import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const getWidgets = async () => {
  const resp = await realBricksApi.get(API_ENDPOINTS.DASHBOARD.GetWidgets);
  return resp.data;
};

export const getPropertyChart = async () => {
  const resp = await realBricksApi.get(
    API_ENDPOINTS.DASHBOARD.GetPropertyChart
  );
  return resp.data;
};

export const getInvestorChart = async () => {
  const resp = await realBricksApi.get(
    API_ENDPOINTS.DASHBOARD.GetInvestorChart
  );
  return resp.data;
};

export const getRecentProperty = async () => {
  const resp = await realBricksApi.get(
    API_ENDPOINTS.DASHBOARD.GetRecentProperty
  );
  return resp.data;
};

export const getNotifications = async (perPage, page, cancelToken) => {
  const resp = await realBricksApi.get(
    `${API_ENDPOINTS.DASHBOARD.GetNotifications}?limit=${
      perPage ? perPage : 10
    }&page=${page ? page : 1}`,
    {
      cancelToken,
    }
  );
  return resp.data;
};
